module.exports = __webpack_public_path__ + "img/SBATDetailed-min.f9ad3fcc.png";